import React from 'react';
import { Typography, Button, Avatar, Menu,TextField, Select, MenuItem,CircularProgress, Backdrop, Checkbox, FormGroup, Chip, Switch } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import API from '../API';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SearchBarComponent from '../components/SearchBarComponent';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import "dayjs/locale/tr";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';

const types = ["Motorsiklet", "Sedan", "Doblo", "Minivan", "Panelvan", "Kamyonet", "Esnek", "Kamyon (6 Teker)", "Kamyon (8 Teker)", "Kamyon (10 Teker)"];
export default class ControlCenter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {loaded: false, popupEdit: false, additionalFeesEdit: false};

        
       

        
    }

    componentDidMount() {
        API.fetch('getcontrolcenter').then(e => {
          this.data = e;
          
          console.log(e);
          this.setState({loaded: true});
        })
    }
    render() {
        
      if(!this.state.loaded)
        return <div></div>

        
        return <div style={{display:"flex", justifyContent:"center"}}>

            <div style={{maxWidth:900, width:"100%"}}>
            


            <Typography variant='h4' style={{marginBottom: 30}}>Kontrol Paneli</Typography>

            <Badge style={{display:"flex",flexDirection:"row", alignItems:"center", gap: 10}}>
                <Typography variant='h6'>Motorsiklet Siparişleri Açık</Typography>
                <Switch onChange={(e) => {
                  this.data.motorcycleOpen = e.target.checked;
                  this.forceUpdate();
                  
                  global.showLoadingPanel();

                  API.fetch('setmotorcycleenabled', {value: this.data.motorcycleOpen}).then(e => {
                    global.hideLoadingPanel();
                  })
                }}  checked={this.data.motorcycleOpen} />
                </Badge>


                <Badge style={{display:"flex", marginTop:20}}>
                <Typography variant='h6'>Hesaplama Popup</Typography>

                <Typography variant='p1'>Müşteriler hesaplama yapıp fiyatı görmek için ilerlediklerinde karşılarına çıkacak olan bilgilendirme popupı</Typography>



                <div style={{display:"flex",flexDirection:"row", alignItems:"center", gap: 10,marginTop:20}}>
                  <Typography variant='h6'>Aktif</Typography>
                <Switch disabled={!this.state.popupEdit} onChange={(e) => {
                  this.data.popup.disabled = !e.target.checked;
                  this.forceUpdate();
                  
                  
                }}  checked={!this.data.popup.disabled} />
                </div>
               


               <Typography variant='body1' style={{marginTop:30,marginBottom:5,fontWeight:"600"}}>Türkçe</Typography>
               <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Başlık</Typography>
                               <TextField disabled={!this.state.popupEdit} value={this.data.popup.header.tr} onChange={(e) => {
                                   this.data.popup.header.tr = e.target.value;
                                   this.forceUpdate();
                               }} size='small' rows={3} multiline onKeyDown={(e) => {
                 if(e.keyCode === 13) {
                   e.preventDefault();
                   
                 }
               }} />
               
               
               
               <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Metin</Typography>
               <TextField disabled={!this.state.popupEdit} value={this.data.popup.body.tr} onChange={(e) => {
                                   this.data.popup.body.tr = e.target.value;
                                   this.forceUpdate();
                               }} size='small' rows={3} multiline onKeyDown={(e) => {
                 if(e.keyCode === 13) {
                   e.preventDefault();
                   
                 }
               }} />


                <Typography variant='body1' style={{marginTop:30,marginBottom:5,fontWeight:"600"}}>İngilizce</Typography>
                                <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Başlık</Typography>
                                <TextField disabled={!this.state.popupEdit} value={this.data.popup.header.en} onChange={(e) => {
                                    this.data.popup.header.en = e.target.value;
                                    this.forceUpdate();
                                }} size='small' rows={3} multiline onKeyDown={(e) => {
                  if(e.keyCode === 13) {
                    e.preventDefault();
                    
                  }
                }} />
                
                <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Metin</Typography>
                <TextField disabled={!this.state.popupEdit} value={this.data.popup.body.en} onChange={(e) => {
                                    this.data.popup.body.en = e.target.value;
                                    this.forceUpdate();
                                }} size='small' rows={3} multiline onKeyDown={(e) => {
                  if(e.keyCode === 13) {
                    e.preventDefault();
                    
                  }
                }} />


                {!this.state.popupEdit && <Button onClick={() => {
                
                                       
                                        this.setState({popupEdit: true});
                                    }} style={{flex:0,width:"fit-content", alignSelf:"flex-end", marginTop:20}} variant='outlined'>Düzenle <EditIcon sx={{width:18, height:18}} style={{marginLeft:10}} /></Button>}

                                    {this.state.popupEdit && <Button onClick={() => {
                
                                       
                                        this.setState({popupEdit: false});

                                        global.showLoadingPanel();

                                        API.fetch('setcalculationpopup', {popup: this.data.popup}).then(e => {
                                          global.hideLoadingPanel();
                                        })
                                    }} style={{flex:0,width:"fit-content", alignSelf:"flex-end", marginTop:20}} variant='contained' color='success'>Kaydet</Button>}

                </Badge>

<Badge style={{display:"flex", gap: 10, marginTop:20}}>
                <Typography variant='h6'>Hesaplama Ek Tarifeleri</Typography>
                
                {this.data.additionalFees.map((x, i) => <div key={i} style={{paddingTop:20, paddingBottom:20, borderTopColor:"gray", borderTopWidth:1, borderTopStyle:"solid",borderBottomColor:"gray", borderBottomWidth:1, borderBottomStyle:"solid"}}>
                  <div style={{display:"flex",flex:1, justifyContent:"space-between"}}>
                        <div style={{display:"flex",flexDirection:"row", alignItems:"center",gap:2}}>
                                    <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Açıklama (Türkçe): </Typography>
                                    <TextField disabled={!this.state.additionalFeesEdit} value={x.desc.tr} onChange={(e) => {
                                      x.desc.tr = e.target.value;
                                      this.forceUpdate();
                                    }} size='small' />
                        </div>
                        <div style={{display:"flex",flexDirection:"row", alignItems:"center",gap:2}}>
                                    <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Açıklama (İngilizce): </Typography>
                                    <TextField disabled={!this.state.additionalFeesEdit} value={x.desc.en} onChange={(e) => {
                                      x.desc.en = e.target.value;
                                      this.forceUpdate();
                                    }} size='small' />
                        </div>
                     </div>

                     <div style={{marginTop:15}}>
                      <div style={{display:"flex",alignItems:"center", gap:5}}>
                         <Typography variant='body1' style={{marginTop:10,marginBottom:5, width:125}}>Başlangıç Tarihi: </Typography>
<LocalizationProvider adapterLocale='tr' dateAdapter={AdapterDayjs}> <DateTimePicker disabled={!this.state.additionalFeesEdit} ampm={false} defaultValue={dayjs(x.start)} onChange={(e) => x.start = e.$d.getTime()} /> </LocalizationProvider>
</div>


<div style={{display:"flex",alignItems:"center", gap:5,marginTop:15}}>
                         <Typography variant='body1' style={{marginTop:10,marginBottom:5, width:125}}>Bitiş Tarihi: </Typography>
<LocalizationProvider adapterLocale='tr' dateAdapter={AdapterDayjs}> <DateTimePicker disabled={!this.state.additionalFeesEdit}  ampm={false} defaultValue={dayjs(x.end)} onChange={(e) => x.end = e.$d.getTime()} /> </LocalizationProvider>
</div>
                     </div>

                                  <div style={{display:"flex",gap:10, marginTop:10,flexDirection:"column"}}>
                     {x.price.map((pricing, pricKey) => <div key={pricKey} style={{display:"flex",flexDirection:"row", alignItems:"center",gap:2}}>
                                    <Typography variant='body1' style={{marginTop:10,marginBottom:5, width:125}}>{types[pricKey]}: </Typography>
                                    <TextField type='number' onChange={(e) => {
                                      x.price[pricKey] = parseFloat(e.target.value);
                                      this.forceUpdate();
                                    }} disabled={!this.state.additionalFeesEdit} value={pricing} size='small' />
                        </div>)}
</div>

{this.state.additionalFeesEdit && <Button onClick={() => {
                
                                       
                                        this.data.additionalFees.splice(i, 1);
                                        this.forceUpdate();
                                    }} style={{flex:0,width:"fit-content", marginTop:20}} variant='outlined' color='error'>Sil</Button>}
                </div>)}


                {!this.state.additionalFeesEdit && <Button onClick={() => {
                
                                       
                                        this.setState({additionalFeesEdit: true});
                                    }} style={{flex:0,width:"fit-content", alignSelf:"flex-end", marginTop:20}} variant='outlined'>Düzenle <EditIcon sx={{width:18, height:18}} style={{marginLeft:10}} /></Button>}

                                    {this.state.additionalFeesEdit && <Button onClick={() => {
                
                                       
                                        this.data.additionalFees.push({
          start: Date.now(),
          end: Date.now(),
          desc: {tr: "", en: ""},
          price: [0,0,0,0,0,0]
        });
        this.forceUpdate();
                                    }} style={{flex:0,width:"fit-content", marginTop:20}} variant='outlined'>Ekle</Button>}

                                    {this.state.additionalFeesEdit && <Button onClick={() => {
                
                                       
                                        this.setState({additionalFeesEdit: false});

                                        global.showLoadingPanel();

                                        API.fetch('setadditionalfees', {additionalFees: this.data.additionalFees}).then(e => {
                                          global.hideLoadingPanel();
                                        })
                                    }} style={{flex:0,width:"fit-content", alignSelf:"flex-end", marginTop:20}} variant='contained' color='success'>Kaydet</Button>}

                </Badge>


 {/* {
          start: 1748980596627-100000,
          end: 1748980596627+100000,
          desc: {tr: "Bayram Tarifesi", en: "Holiday Surcharge"},
          price: [250,250,450,650,650,850]
        } */}

        </div>
        </div>
    }


   
}




var dateFromObjectId = function (objectId) {
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

const Badge = (props) => {
    return <div style={{backgroundColor:"white",display:"flex",flexDirection:"column", flex:1,boxShadow:"rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px", borderRadius:8,padding:24, color:"rgb(18, 24, 40)",...props.style}}>
        {props.children}
    </div>
}

function diacriticSensitiveRegex(string = '') {
  return '' + (string.replace(/\+/g,'').replace(/[Iİıi]/g, '[I,İ,ı,i]').replace(/[öÖoO]/g, '[ö,Ö,o,O]').replace(/[şŞsS]/g, '[ş,Ş,s,S]').replace(/[çÇcC]/g, '[ç,Ç,c,C]').replace(/[ğĞgG]/g, '[ğ,Ğ,g,G]').replace(/[uUÜü]/g, '[u,U,Ü,ü]')).split(/\,|\s/).join(' ') + ''
 }
